var loader = require('./dist/index');

module.exports = loader;